<template>
  <PrivacySection title="9. Sicurezza dei Dati">
    <p>
      Adottiamo misure tecniche e organizzative appropriate per proteggere i dati personali 
      da accesso non autorizzato, alterazione, divulgazione o distruzione. Tali misure includono:
    </p>
    <ul>
      <li>Crittografia dei dati in transito (HTTPS/SSL)</li>
      <li>Limitazione dell'accesso ai dati personali solo al personale autorizzato</li>
      <li>Backup regolari e procedure di ripristino</li>
      <li>Monitoraggio continuo per individuare e prevenire violazioni della sicurezza</li>
      <li>Memorizzazione locale dei dati sensibili dell'applicazione sul dispositivo dell'utente</li>
    </ul>
    <p>
      Nonostante le misure adottate, nessun sistema di trasmissione o memorizzazione 
      di dati è completamente sicuro. Pertanto, non possiamo garantire la sicurezza 
      assoluta dei dati personali.
    </p>
  </PrivacySection>
</template>

<script>
import PrivacySection from '../PrivacySection.vue'

export default {
  name: 'SecuritySection',
  components: {
    PrivacySection
  }
}
</script>

